export function partnersInfoItemSlider() {
    let slider = $(".partners-info-slider .item");
    $(window).on("load resize", function () {
        sliderInit();
    });

    function sliderInit() {
        if (window.innerWidth >= 1024 && !slider.hasClass("slick-initialized")) {
            sliderOption();
        }
        if (window.innerWidth < 1024 && slider.hasClass("slick-initialized")) {
            slider.slick("unslick");
        }
    }

    function sliderOption() {
        slider.each(function () {
            $(this).slick({
                slidesToScroll: 1,
                slidesToShow: 1,
                fade: true
                // arrows: false,
                // variableWidth: true
            });
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/partnersInfoItemSlider.js